import React, { Component } from 'react'
import './DialerBottom.css'
// import "flatpickr/dist/themes/material_green.css";
// import Flatpickr from "react-flatpickr";
import { Dropdown } from 'react-bootstrap';
import * as callReq from '../../../../axios/requests/callReq'
import ExtensionDropdownItem from './ExtensionDropdown';
import { isPbxSupportActionType } from '../../../../util/functions'
import Calendar from '../../../UI/Calendar/Calendar';
import { withTranslation } from 'react-i18next';
// import { phonePattern } from '../../../../util/constants'


class DialerBottom extends Component {
    state = {
        FlatpickrDate: null,
        inputTransferToPhone: '',
        inputConfToPhone: '',
        extensionStatuses: [],
        showDialListRejectCalendar: false
    }

    onToggelDialListRejectCalendarHandler = () => {
        this.setState((prevState) => ({
            showDialListRejectCalendar: !prevState.showDialListRejectCalendar
        }));
    }

    onConfirmDateClickedHandler = (date) => {
        // if(this.props.inCall && this.props.isCallAnswered){
        this.props.OnInCallPostponedClickedAndClosed(date)
        // }

    }

    handleOnViewCrmContactClicked = (phone, crm) => {
        this.props.onOpenContactCrmWindowClicked(undefined, crm, undefined, phone, true)
    }

    handleBtnFetchExtensionsStatus = async () => {
        try {
            const extensionStatuses = await callReq.checkExtenstionsStatus();
            this.setState({ extensionStatuses });
        } catch (error) {
            console.error(error?.response?.data?.msg);
        }
    }

    handleOnInputTransferToPhoneChange = (event) => {
        // if (event.target.value.length <= 10)
        this.setState({ inputTransferToPhone: event.target.value.replace(/[^\d]/, '') })
    }
    handleOninputConfToPhoneChange = (event) => {
        // if (event.target.value.length <= 10)
        this.setState({ inputConfToPhone: event.target.value.replace(/[^\d]/, '') })
    }
    handleOnInputTransferToPhoneDropDownSelect = (selectedItem) => {
        // if (selectedItem.length <= 10 && selectedItem.length <= 10)
        // if (phonePattern.test(selectedItem)) {
        this.setState({ inputTransferToPhone: selectedItem.replace(/[^\d]/, '') })
        callReq.transferCall(this.props.callId, selectedItem)
        // }

    }
    handleOninputConfToPhoneDropDownSelect = async (selectedItem) => {//this.props.callConfStart
        // if (selectedItem.length <= 10 && selectedItem.length > 1) {
        // if (phonePattern.test(selectedItem)) {
        this.setState({ inputConfToPhone: selectedItem.replace(/[^\d]/, '') })
        const resData = await callReq.confCall(this.props.callId, selectedItem.replace(/[^\d]/, ''))
        if (resData) {
            this.props.callConfStart(resData.callId, resData.phone)
        }
        // }
    }

    handleOnInputConfToPhoneBtnClicked = async () => {//this.props.callConfStart
        // if (this.state.inputConfToPhone.length > 1 && this.state.inputConfToPhone.length <= 10) {
        // if (phonePattern.test(this.state.inputConfToPhone)) {
        const resData = await callReq.confCall(this.props.callId, this.state.inputConfToPhone)
        if (resData) {
            this.props.callConfStart(resData.callId, resData.phone)
        }
        // }
    }
    handleOnInputTransferToPhoneBtnClicked = () => {
        // if (this.state.inputTransferToPhone.length > 1 && this.state.inputTransferToPhone.length <= 10) {
        // if (phonePattern.test(this.state.inputTransferToPhone)) {
        callReq.transferCall(this.props.callId, this.state.inputTransferToPhone)
        // }
    }

    handleOnChannelSelect = (channelId, msgType) => {
        this.props.OnNewConvChannelSelected(msgType)
        this.props.onNewConvName(channelId)
        setTimeout(() => this.props.OnNewConvClicked(), 0)
    }

    render() {

        const { pbxType, inCall, isCallFromDialList } = this.props
        const isNewCall = !inCall && !isCallFromDialList
        let callerName = '';
        if ((this.props.name !== this.props.phoneInput)) callerName = this.props.name

        let dialerMenu = 'row dialerMenu';

        if (this.props.inCall && callerName && this.props.crm) {
            dialerMenu += ' dialerMenuShifted';
        }

        let dialerIcon
        if (this.props.callColor === 'dialIconGreen' && this.props.projectDesc) {
            dialerIcon = 'fas fa-phone fa-2x dialIcon dialIconBlue'
        }
        else {
            dialerIcon = 'fas fa-phone fa-2x dialIcon ' + this.props.callColor
        }

        // when open a dialer 
        let extensionsMainPhoneElements;
        if (this.props.companyExts) {
            extensionsMainPhoneElements = this.props.companyExts.map(extension => (
                <ExtensionDropdownItem
                    key={extension._id}
                    extension={extension}
                    onItemSelected={this.props.oninputMainPhoneDropDownSelect}
                    listOfOnlineAgents={this.props.listOfOnlineAgents}
                    extensionStatuses={this.state.extensionStatuses}
                />
            ));
        }

        // transfer phone
        let extensionsTransferPhoneElements;
        if (this.props.companyExts) {
            extensionsTransferPhoneElements = this.props.companyExts.map(extension => (
                <ExtensionDropdownItem
                    key={extension._id}
                    extension={extension}
                    onItemSelected={this.handleOnInputTransferToPhoneDropDownSelect}
                    listOfOnlineAgents={this.props.listOfOnlineAgents}
                    extensionStatuses={this.state.extensionStatuses}
                />
            ));
        }

        // conference call
        let extensionsConfPhoneElements;
        if (this.props.companyExts) {
            extensionsConfPhoneElements = this.props.companyExts.map(extension => (
                <ExtensionDropdownItem
                    key={extension._id}
                    extension={extension}
                    onItemSelected={this.handleOninputConfToPhoneDropDownSelect}
                    listOfOnlineAgents={this.props.listOfOnlineAgents}
                    extensionStatuses={this.state.extensionStatuses}
                />
            ));
        }

        // let callerName = ''


        // if ((this.props.name !== this.props.phoneInput)) callerName = this.props.name

        let actionsContainer = null
        // if (this.props.inCall && this.props.isCallAnswered) 
        actionsContainer =
            <div className='inCallActions'>
                <div className="call-actions">
                    {!isNewCall && <div className="reject-call-container">
                        <Calendar
                            showCalendar={this.state.showDialListRejectCalendar}
                            onToggelCalendar={this.onToggelDialListRejectCalendarHandler}
                            onConfirmDateClicked={this.onConfirmDateClickedHandler}
                        ></Calendar>
                        <i className="far fa-clock fa-lg call-action-btn" title={this.props.t('Call rejection')} onClick={this.onToggelDialListRejectCalendarHandler} />
                    </div>}
                    {this.props.inCall && this.props.isCallAnswered && isPbxSupportActionType(pbxType, 'TRANSFER_CALL') && <Dropdown drop='left' className="transferCallDropDownSection">
                        <Dropdown.Toggle variant='outline-success' className='transferCallBtn'><i className="far fa-arrow-alt-circle-right call-action-btn" title={this.props.t('Call transfer')} /></Dropdown.Toggle>
                        <Dropdown.Menu className="transferCallMenu">
                            <div className="transferPhoneNumDiv">
                                <i className="far fa-check-circle transferPhoneNumAcceptBtn" onClick={this.handleOnInputTransferToPhoneBtnClicked}></i>
                                <div className="inputTransferPhoneNumGroup">
                                    <Dropdown drop='up' className="transferCallDropDownSection">
                                        <Dropdown.Toggle variant='outline-success' className='transferCallBtn'><i onClick={this.handleBtnFetchExtensionsStatus} className="fas fa-user searchDevices" /></Dropdown.Toggle>
                                        <Dropdown.Menu className="transferCallMenu">
                                            <h6 className='mainTitleAgentExtList'>{this.props.t('Extensions and agents list')}</h6>
                                            {extensionsTransferPhoneElements}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <input onChange={this.handleOnInputTransferToPhoneChange} className="transferPhoneNumTextInput" value={this.state.inputTransferToPhone} type='text' />

                                </div>
                                <span className="transferPhoneNumLabel">{this.props.t('Phone')}</span>
                            </div >
                        </Dropdown.Menu>
                    </Dropdown>}
                    {this.props.inCall && this.props.isCallAnswered && isPbxSupportActionType(pbxType, 'CONFERENCE_CALL') && <Dropdown drop='left' className="transferCallDropDownSection">
                        <Dropdown.Toggle variant='outline-success' className='transferCallBtn'><i className="fa-regular fa-circle-user call-action-btn" title={this.props.t('Conference call')} /></Dropdown.Toggle>
                        <Dropdown.Menu className="transferCallMenu">
                            <div className="transferPhoneNumDiv">
                                <i className="far fa-check-circle transferPhoneNumAcceptBtn" onClick={this.handleOnInputConfToPhoneBtnClicked}></i>
                                <div className="inputTransferPhoneNumGroup">
                                    <Dropdown drop='up' className="transferCallDropDownSection">
                                        <Dropdown.Toggle variant='outline-success' className='transferCallBtn'><i onClick={this.handleBtnFetchExtensionsStatus} className="fas fa-user searchDevices" /></Dropdown.Toggle>
                                        <Dropdown.Menu className="transferCallMenu">
                                            <h6 className='mainTitleAgentExtList'>{this.props.t('Extensions and agents list')}</h6>
                                            {extensionsConfPhoneElements}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <input onChange={this.handleOninputConfToPhoneChange} className="transferPhoneNumTextInput" value={this.state.inputConfToPhone} type='text' />

                                </div>
                                <span className="transferPhoneNumLabel">{this.props.t('Phone')}</span>
                            </div >
                        </Dropdown.Menu>
                    </Dropdown>}
                    {this.props.inCall && this.props.isCallAnswered && isPbxSupportActionType(pbxType, 'HOLD_CALL') && <div className="hold-call-container">
                        <i title={this.props.t('Hold call')} onClick={() => callReq.putCallOnHoldOrTalk(this.props.callId)} className={`fa-regular fa-circle-pause call-action-btn ${this.props.isOnHold ? 'call-action-btn--red' : ''}`} />
                    </div>}
                    {
                        !isNewCall && <i style={{ fontSize: '15px' }} title={this.props.t('End treatment')} onClick={this.props.onBmcFinishClicked} className="fa-solid fa-flag-checkered call-action-btn" />
                    }
                </div>
                <div className='call-channels'>
                    <i className="fab fa-whatsapp-square DialerBottom_whatsapp" onClick={() => this.handleOnChannelSelect(this.props.phoneInput, 'whatsapp')} />
                    <i className="fas fa-sms DialerBottom_sms" onClick={() => this.handleOnChannelSelect(this.props.phoneInput, 'sms')} />
                </div>
            </div>




        // const callStatus = <div className="caller-name-container">
        //     <input className='caller-name-input' disabled value={this.props.callStatusDisplay + ' ' +callerName} type='text' />
        //     <i className="fa-solid fa-link caller-crm-link-btn" />
        // </div>
        let contactDetails
        if (this.props.inCall && callerName && this.props.crm) {//&& !this.props.isCallAnswered

            contactDetails =
                <div className="caller-name-container" >
                    <input className='caller-name-input' onClick={() => this.handleOnViewCrmContactClicked(this.props.phoneInput, this.props.crm)} readOnly value={callerName} type='text' />
                </div>
        }


        // if (!this.props.name || this.props.name === this.props.phoneInput) callerName = ''
        // else callerName = this.props.name + '-'


        return (
            <div className='row dialerBottom'>
                <div className='col-12 costContactsCol '>
                    <div className={dialerMenu}>
                        <div className='col-8'>
                            <div className='row'>
                                <div className="transferPhoneNumDiv">
                                    {
                                        (this.props.inCall || this.props.isCallFromDialList) ?
                                            <Dropdown drop='up' show={!(this.props.inCall || this.props.isCallFromDialList)} className="transferCallDropDownSection">
                                                <Dropdown.Toggle variant='outline-success' className='transferCallBtn'><i className="fas fa-user searchDevices searchDevicesMainPhone" /></Dropdown.Toggle>
                                                <Dropdown.Menu className="transferCallMenu">
                                                    <h6 className='mainTitleAgentExtList'>{this.props.t('Extensions and agents list')}</h6>
                                                    {extensionsMainPhoneElements}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                            :
                                            <Dropdown drop='up' className="transferCallDropDownSection">
                                                <Dropdown.Toggle variant='outline-success' className='transferCallBtn'><i onClick={this.handleBtnFetchExtensionsStatus} className="fas fa-user searchDevices searchDevicesMainPhone" /></Dropdown.Toggle>
                                                <Dropdown.Menu className="transferCallMenu">
                                                    <h6 className='mainTitleAgentExtList'>{this.props.t('Extensions and agents list')}</h6>
                                                    {extensionsMainPhoneElements}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                    }
                                    <input className='phoneInput' onKeyDown={(e) => this.props.onKeyBoardClick(e, 'newCallBtnClicked')} disabled={this.props.inCall || this.props.isCallFromDialList} placeholder={this.props.t('Enter phone')} value={this.props.phoneInput} onChange={this.props.onPhoneInput} type='text'></input>
                                </div>
                                <p className='callStatusText'>
                                    {/* {callStatus} */}
                                    {this.props.callStatusDisplay}{this.props.projectDesc && <i title={this.props.t('Callback from') + this.props.projectDesc} className="fas fa-voicemail cusVoiceMail" />}
                                </p>
                                {/* {contactDetails} */}


                            </div>
                        </div>
                        <div className='col-4 costCallCol'>
                            <i onClick={this.props.onExitDialerClicked} className="far fa-times-circle costExit"></i>
                            <i className={dialerIcon} onClick={this.props.CallBtClicked}></i>
                        </div>
                        <div className='col-12 '>
                            {actionsContainer}
                        </div>
                        <div className='col-12 '>
                            {contactDetails}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withTranslation('common')(DialerBottom)